"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SharedConstants {
}
SharedConstants.FileUploadTypes = ".pdf, .docx, .doc, .jpeg, .jpg, .png, .tiff, .tiff2, .tif, .rtf";
SharedConstants.FileUploadTypesArray = ["pdf", "docx", "doc", "jpeg", "jpg", "png", "tiff", "tiff2", "tif", "rtf"];
SharedConstants.SPREADSHEET_FILE_EXTENSIONS = ["csv", "xls", "xlsx"];
exports.default = SharedConstants;
//# sourceMappingURL=SharedConstants.js.map